import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import { logout } from '../Api/auth';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function NotAuthorized() {
  const handleLogout = () => {
    logout();
    window.location.replace('/login');
  };

  return (
    <>
      <Helmet>
        <title> Not Authorized </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            You are not authorized
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Your account doesn&apos;t have access to any section of this portal. Please contact your administrator.
          </Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button size="large" variant="contained" onClick={handleLogout}>
            Log Out
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
